<div
  class="surface-card group overflow-hidden cursor-pointer flex flex-col hover:border-border-primary transition-all duration-300"
  (click)="onClick()"
>
  <!-- Image -->
  <div class="relative h-60 overflow-hidden shrink-0 bg-surface-elevated">
    <img
      [src]="imageUrl"
      [alt]="name"
      class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
      loading="lazy"
    />

    <!-- Overlay -->
    <div class="absolute inset-0 bg-gradient-to-t from-surface via-surface/20 to-transparent opacity-90"></div>

    <!-- Top Badges -->
    <div class="absolute top-4 left-4 flex flex-col gap-2">
      <!-- Delivery Badge -->
      @if (deliveryDate) {
        <div
          class="px-3 py-1.5 text-xs rounded-full bg-surface-elevated/90 backdrop-blur-md border border-border-subtle flex items-center gap-1.5 shadow-subtle"
        >
          <i class="fa-solid fa-clock text-primary text-[10px]"></i>
          <span class="text-text-primary font-mono font-bold"
            >{{ 'projects.card.delivery' | translate }} {{ deliveryDate }}</span
          >
        </div>
      }

      <!-- Featured / Trusted Badge -->
      @if (isFeatured) {
        <div class="px-2.5 py-1 text-[10px] rounded-full bg-warning-soft border border-warning-border text-warning font-mono font-black uppercase tracking-wider self-start shadow-sm">
          <i class="fa-solid fa-sparkles mr-1"></i> Featured
        </div>
      }
    </div>

    <!-- Quick Action / Favorite -->
    <div class="absolute top-4 right-4">
      <button
        type="button"
        (click)="toggleFavorite($event)"
        class="w-9 h-9 flex items-center justify-center bg-surface-elevated/90 backdrop-blur-md border border-border-subtle rounded-full shadow-subtle hover:bg-surface-hover hover:border-border-primary transition-all group/heart"
        aria-label="Toggle Favorite"
      >
        <i
          class="fa-solid fa-heart transition-colors"
          [class.text-primary]="isFavorite"
          [class.text-text-muted]="!isFavorite"
          [class.group-hover/heart:text-primary]="!isFavorite"
        ></i>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="p-5 flex flex-col flex-1 relative">
    <!-- Title + Developer -->
    <div class="flex items-start gap-4 mb-4">
      <div class="w-12 h-12 shrink-0 bg-surface-elevated border border-border-subtle rounded-xl flex items-center justify-center shadow-inner-glow group-hover:border-border-primary transition-colors duration-300">
        <i class="fa-solid fa-building text-text-secondary group-hover:text-primary transition-colors duration-300"></i>
      </div>

      <div class="flex-1 min-w-0 pt-0.5">
        <h3
          class="text-text-primary font-semibold text-lg leading-tight line-clamp-1 group-hover:text-primary transition-colors duration-300 font-mono tracking-tight"
        >
          {{ name }}
        </h3>
        @if (developer) {
          <div class="text-text-muted text-xs mt-1.5 line-clamp-1 font-medium">
            {{ developer }}
          </div>
        }
      </div>
    </div>

    <!-- Location -->
    @if (location) {
      <div class="flex items-center gap-2 text-text-secondary text-xs mb-4">
        <i class="fa-solid fa-location-dot text-text-muted text-[11px]"></i>
        <span class="line-clamp-1 font-medium">{{ location }}</span>
      </div>
    }

    <!-- Unit Types -->
    @if (unitTypes.length > 0) {
      <div class="flex flex-wrap gap-2 mb-5">
        @for (type of unitTypes; track type) {
          <span class="badge badge-neutral text-[10px] font-mono font-medium tracking-wide">
            {{ type }}
          </span>
        }
      </div>
    }

    <div class="mt-auto">
      <!-- Footer -->
      <div class="flex items-center justify-between border-t border-border-subtle pt-4">
        <!-- Price -->
        <div>
          <div class="text-[11px] text-text-muted mb-0.5">{{ 'projects.card.startingFrom' | translate }}</div>
          <div class="text-base font-bold text-text-primary group-hover:text-primary transition-colors duration-300 font-mono">
            {{ startingPrice | number }}
            <span class="text-xs font-bold text-primary">{{ currency }}</span>
          </div>
        </div>

        <!-- Units -->
        @if (totalUnits > 0) {
          <div class="flex flex-col items-end text-xs text-text-secondary">
            <div class="flex items-center gap-1.5 mb-0.5">
              <i class="fa-solid fa-cubes text-text-muted text-[10px]"></i>
              <span class="font-mono font-bold text-text-primary">{{ totalUnits }}</span>
            </div>
            <span class="text-[10px] text-text-muted">{{ 'projects.card.units' | translate }}</span>
          </div>
        }
      </div>

      <!-- CTA -->
      <button
        type="button"
        class="btn btn-secondary w-full mt-4 group-hover:border-primary/50 group-hover:text-primary text-xs font-mono font-bold uppercase tracking-wider transition-all duration-300 py-2.5 rounded-xl"
      >
        {{ 'projects.card.viewProject' | translate }}
      </button>
    </div>
  </div>
</div>
